// Fluxo de Caixa – Receitas da Operação (specs/001-fluxo-caixa-receitas).
// Só desenha o que o servidor manda em data-chart: alturas em centavos e rótulos prontos.
// Nenhum valor monetário é somado, filtrado ou formatado aqui (constituição, princípio IV).
import c3 from 'c3'

const FORECAST_COLOR = '#E8590C'
const REALIZED_COLOR = '#40C057'
const HATCH_ID = 'cf-hatch'

function addHatchPattern(svg) {
  if (svg.querySelector(`#${HATCH_ID}`)) return

  const ns = 'http://www.w3.org/2000/svg'
  const defs = svg.querySelector('defs') || svg.insertBefore(document.createElementNS(ns, 'defs'), svg.firstChild)
  const pattern = document.createElementNS(ns, 'pattern')
  pattern.setAttribute('id', HATCH_ID)
  pattern.setAttribute('patternUnits', 'userSpaceOnUse')
  pattern.setAttribute('width', '6')
  pattern.setAttribute('height', '6')
  pattern.setAttribute('patternTransform', 'rotate(45)')
  pattern.innerHTML = `<rect width="6" height="6" fill="${REALIZED_COLOR}"></rect>` +
    '<line x1="0" y1="0" x2="0" y2="6" stroke="#FFFFFF" stroke-width="2"></line>'
  defs.appendChild(pattern)
}

// Rótulo do eixo Y em milhares de reais (0k, 15k...). É só a escala da grade, não um valor exibido.
function axisLabel(cents) {
  return `${Math.round(cents / 100000)}k`
}

export function drawCashFlowChart(element, { onSelect } = {}) {
  if (!element || !element.dataset.chart) return null

  const data = JSON.parse(element.dataset.chart)
  const tooltipLabels = { Previsto: data.forecast_labels, Realizado: data.realized_labels }
  const barLabels = { Previsto: data.forecast_bar_labels, Realizado: data.realized_bar_labels }
  // O C3 também chama o format só com um número, para medir o espaço dos rótulos;
  // nesse caso devolvemos o rótulo mais longo, sem formatar nada no cliente.
  const longest = (list) => list.reduce((found, label) => (label.length > found.length ? label : found), '')
  const labelFrom = (source) => (id, index) => {
    if (source[id] && index !== undefined) return source[id][index]
    return longest(source.Previsto.concat(source.Realizado))
  }
  const barLabelFor = labelFrom(barLabels)
  const tooltipLabelFor = labelFrom(tooltipLabels)

  const chart = c3.generate({
    bindto: element,
    data: {
      columns: [['Previsto'].concat(data.forecast_cents), ['Realizado'].concat(data.realized_cents)],
      type: 'bar',
      colors: { Previsto: FORECAST_COLOR, Realizado: REALIZED_COLOR },
      labels: { format: (_value, id, index) => barLabelFor(id, index) },
      onclick: (d) => onSelect && onSelect(data.months[d.index])
    },
    bar: { width: { ratio: 0.7 } },
    axis: {
      x: { type: 'category', categories: data.categories },
      y: { tick: { format: axisLabel } }
    },
    grid: { y: { show: true } },
    legend: { show: false },
    tooltip: { format: { value: (_value, _ratio, id, index) => tooltipLabelFor(id, index) } },
    onrendered: function () {
      addHatchPattern(element.querySelector('svg'))
      const selectedIndex = data.months.indexOf(data.selected)
      element.querySelectorAll('.c3-event-rect, .c3-event-rects rect').forEach((rect, index) => {
        rect.classList.toggle('cash-flow-selected', index === selectedIndex)
      })
    }
  })

  return chart
}

function monthLink(month) {
  return document.querySelector(`.cash-flow-months__link[data-cash-flow-month="${month}"]`)
}

function markSelected(month) {
  document.querySelectorAll('.cash-flow-months__link').forEach((link) => {
    const selected = link.dataset.cashFlowMonth === month
    link.classList.toggle('is-selected', selected)
    if (selected) link.setAttribute('aria-current', 'true')
    else link.removeAttribute('aria-current')
  })

  const monthly = document.getElementById('cash-flow-monthly-chart')
  const data = JSON.parse(monthly.dataset.chart)
  const selectedIndex = data.months.indexOf(month)
  monthly.querySelectorAll('.c3-event-rect, .c3-event-rects rect').forEach((rect, index) => {
    rect.classList.toggle('cash-flow-selected', index === selectedIndex)
  })
  data.selected = month
  monthly.dataset.chart = JSON.stringify(data)
}

// Troca o bloco do mês via XHR (FR-018). Sem JS, o link recarrega a página com o mês.
function selectMonth(month) {
  const container = document.getElementById('cash-flow-month')
  const url = `${container.dataset.url}?month=${encodeURIComponent(month)}`

  fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
    .then((response) => {
      if (!response.ok) throw new Error(response.status)
      return response.text()
    })
    .then((html) => {
      container.innerHTML = html
      markSelected(month)
      drawCashFlowChart(document.getElementById('cash-flow-daily-chart'))
      const link = monthLink(month)
      if (link) window.history.replaceState(window.history.state, '', link.href)
    })
    .catch(() => {
      const link = monthLink(month)
      if (link) window.location.href = link.href
    })
}

document.addEventListener('turbolinks:load', function () {
  const monthly = document.getElementById('cash-flow-monthly-chart')
  if (!monthly) return

  drawCashFlowChart(monthly, { onSelect: selectMonth })
  drawCashFlowChart(document.getElementById('cash-flow-daily-chart'))

  document.querySelectorAll('.cash-flow-months__link').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault()
      selectMonth(link.dataset.cashFlowMonth)
    })
  })
})
